export const NavCountPill = ({ count }: { count: number }) => (
  <div className="flex items-center justify-center rounded bg-danger-500 text-xxs text-background-1000 px-2">
    {count}
  </div>
);
